import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { clearAuthData } from '../redux/AuthSlice';

const PrivateRoute = ({ redirectPath = '/' }) => {
    const token = useSelector((state) => state.auth.token);
    const dispatch = useDispatch();
    const location = useLocation();

    // More robust token validation
    const isAuthenticated = Boolean(token && token.length > 0);

    useEffect(() => {
        if (!isAuthenticated) {
            dispatch(clearAuthData());
        }
    }, [dispatch, isAuthenticated]);

    if (!isAuthenticated) {
        // Preserve the attempted URL for redirect after login
        return <Navigate to={redirectPath} state={{ from: location }} replace />;
    }

    return <Outlet />;
};

export default PrivateRoute;